import React from 'react';
import './ProductHighlight.css';

const ProductHighlight = () => {
  return (
    <section id="product-highlight" className="highlight-section">
      <div className="highlight-image-wrapper">
        <img 
          src="/images/product-highlight.jpg" 
          alt="Product Highlights" 
          className="highlight-full-image" 
          loading="lazy"
          decoding="async"
        />
      </div>
    </section>
  );
};

export default ProductHighlight;
